export default __webpack_public_path__ + "static/media/insta.7c39db08.svg";